import { createSlice } from "@reduxjs/toolkit"

export const customerCollectiontSlice = createSlice({
	name: "customerCollection",
	initialState: {
		customerCollection: "",
		errors: [],
	},

	reducers: {
        getCustomerCollection: (state, action) => {
            // console.log(action.payload);
			state.customerCollection = action.payload
		},
		getCustomerAllCollection: (state, action) => {
            // console.log(action.payload);
			state.customerCollection = action.payload
		},
		getErrors: (state, action) => {
            
			state.errors = action.payload
		},
	},
})
export const {getCustomerCollection, getCustomerAllCollection, getErrors} = customerCollectiontSlice.actions

export default customerCollectiontSlice.reducer
